export default "__VITE_ASSET__CO7lCVQ3__"